module.exports = __webpack_public_path__ + "static/img/img15.ba5c112.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img15.png
// module id = TEdi
// module chunks = 1